import { render, staticRenderFns } from "./the-sadie-family-wines.vue?vue&type=template&id=4142aa1a&scoped=true"
import script from "./the-sadie-family-wines.vue?vue&type=script&lang=js"
export * from "./the-sadie-family-wines.vue?vue&type=script&lang=js"
import style0 from "./the-sadie-family-wines.vue?vue&type=style&index=0&id=4142aa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4142aa1a",
  null
  
)

export default component.exports